import { EmptyState, buttonStyles } from '@lumlab/platform-ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export function NotFoundPage() {
    const { t } = useTranslation();
    return (
        <div className="flex items-center justify-center p-8">
            <EmptyState
                title={t('platform.errors.not_found')}
                action={
                    <Link className={buttonStyles()} to="/">
                        {t('platform.shell.home')}
                    </Link>
                }
            />
        </div>
    );
}
